import React from "react";

import styled from "styled-components/macro";

import { standardFilter } from "components/Form/FormikControls";
import { Column, Row } from "components/Layout";
import { ConsignmentAutocomplete } from "components/SaleLotForms/ConsignmentAutocomplete";

import { LotNumber } from "./LotNumber";

const Header = styled(Row)`
  border-bottom: 1px solid #e9e9e9;
  margin: 0 -12px;
  padding: 6px 12px;
  grid-gap: 8px;
`;

const Vendor = ({ readOnly }) => {
  return (
    <Column full>
      <ConsignmentAutocomplete
        name="consignment_id"
        filterOptions={standardFilter}
        disabled={readOnly}
        includeSelectedConsignmentWarnings
        selectedEditButtonDataTour="editVendor"
        selectedEditButtonSize={4}
        showSelectedAsCard
      />
    </Column>
  );
};

export const ConsignmentSectionHeader = ({ readOnly, ns = null }) => {
  return (
    <Header justifyBetween>
      <Vendor readOnly={readOnly} ns={ns} />
      <Column>
        <LotNumber readOnly={readOnly} ns={ns} />
      </Column>
    </Header>
  );
};
